import React, { useState } from "react";
import ImageGalleryModal from "../../../common/ImageGalleryModal";
import { formatImageUrl } from "@/lib/general";
import LazyLoad from "../../image/LazyLoad";

const ResponsiveHotelImages = ({
  lodgingDetails,
  lodging,
}: {
  lodgingDetails: any;
  lodging: any;
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 mb-4 relative">
        {/* Main large image */}
        <div className="col-span-1 sm:col-span-2 lg:col-span-2 lg:row-span-2">
          <div className="relative h-[14rem] sm:h-[18rem] lg:h-[18rem]">
            <LazyLoad
              src={formatImageUrl(lodgingDetails?.images?.[0], "high")}
              lowResSrc={formatImageUrl(lodgingDetails?.images?.[0], "low")}
              alt={lodging.name}
              className="w-full h-full rounded-lg"
              objectFit="cover"
            />
          </div>
        </div>

        {/* Smaller images */}
        {lodgingDetails?.images?.slice(1, 5).map((image: any, index: any) => (
          <div key={index} className="relative">
            <div className="h-[14rem] sm:h-[9rem] lg:h-[8.5rem]">
              <LazyLoad
                src={formatImageUrl(image, "medium")}
                lowResSrc={formatImageUrl(image, "low")}
                alt={`${lodging.name} ${index + 1}`}
                className="w-full h-full rounded-lg"
                objectFit="cover"
              />
            </div>
          </div>
        ))}

        {/* View all images button */}
        <button
          onClick={() => setIsModalOpen(true)}
          className="absolute bottom-2 right-2 bg-white bg-opacity-90 hover:bg-opacity-100 text-gray-800 p-2 rounded-lg text-xs font-medium transition-all duration-200 shadow-md"
        >
          View All
        </button>
      </div>

      {/* Image Gallery Modal */}
      <ImageGalleryModal
        images={lodgingDetails?.images || []}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        alt={lodging.name}
        hotelName={lodging.name}
      />
    </>
  );
};

export default ResponsiveHotelImages;
